import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { FuncoPrevidenciaModel } from '../../../shared/models/fundo-previdencia.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { SuperavitModel } from '../../../shared/models/superavit.model';
import { PBDCSuperavitPdf } from '../../../shared/services/documentos-pdf-imprimir/Plano/pbdc/pbdc-superavit-pdf';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { PbdcService } from '../service/pbdc.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';
import { Paginator } from 'primeng/primeng';

@Component({
  selector: 'app-pbdc-superavit',
  templateUrl: './pbdc-superavit.component.html',
  styleUrls: ['./pbdc-superavit.component.css']
})
export class PbdcSuperavitComponent implements OnInit {

  componentes: any[] = [1];

  nrSuperavit = 3;


  @BlockUI() blockUi: NgBlockUI;
  @ViewChild('p') paginator: Paginator;
  page = 0;
  rows = 14;
  totalRecords = 0;

  linkAtivo = false;
  linkPatronal = false;
  linkPatronalCentrus = false;
  linkAssistido = false;
  linkPatronalAssistido = false;
  linkReversao = false;
  tipo = 0;

  verificarPatronalRetorno = false;

  fundoPrevidencia: Array<FuncoPrevidenciaModel> = Array<FuncoPrevidenciaModel>();


  superavitModel: Array<SuperavitModel> = new Array<SuperavitModel>();

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  cdCentrus: number;
  cdCentrusTit: number;


  param: string;
  titulo: string;
  mensagem: string;
  mensagemFooter: string;

  constructor(
    private pBDCSuperavitPdf: PBDCSuperavitPdf,
    private pbdcService: PbdcService,
    private router: Router,
    private toastrService: ToastrService,
    private authInterceptor: AuthInterceptor,
    private pessoaService: PessoaService,
    private changeDetector: ChangeDetectorRef,
  ) { }

  ngOnInit() {

    this._gerenciarCodigoIndentificao();
  }


  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {
        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuPlanos';
        }
        this.getPessoasDadosSimplificado();
      })
  }

  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.validarLinks();
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }

  async validarLinks() {
    try {
      this.cdCentrusTit = await this.pessoaService.getCdCentrusTitular(this.cdCentrus);
      if (!this.cdCentrusTit) { this.cdCentrusTit = this.cdCentrus };
      this.linkAtivo = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 1, this.nrSuperavit);
      this.linkAssistido = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 4, this.nrSuperavit);
      this.linkReversao = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 6, this.nrSuperavit);

        console.log(this.linkReversao)

      if (this.linkAtivo) {
        this.tipo = 1;
      }
      if (this.linkAssistido) {
        this.tipo = 4;
      }

      if (this.tipo === 1 || this.tipo === 4) {
        this.linkPatronal = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 2, this.nrSuperavit)
        this.linkPatronalCentrus = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 3, this.nrSuperavit)
        this.linkAssistido = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 4, this.nrSuperavit)
        this.linkPatronalAssistido = await this.pbdcService.getVerificarPatronal(this.cdCentrus, this.cdCentrusTit, 5, this.nrSuperavit)
      }

      this.getPageConsultaSuperavitCentrus(this.tipo);
      this.selecionamentoTituloTipo();

    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }

  selecionamentoTituloTipo() {
    switch (this.tipo) {
      case 1:
        this.titulo = 'Fundo Previdencial de Utilização Individual'
        break;
      case 2:
        this.titulo = 'Fundo Previdencial de Utilização Patronal'
        break;
      case 4:
        this.titulo = 'Fundo Previdencial de Utilização Individual'
        break;
      default:
        break;
    }
  }

  paginacao(evento, tipo: Number) {
    this.page = evento['page'];
    this.rows = evento['rows'];
    this.getPageConsultaSuperavitCentrus(tipo);
  }

  async getPageConsultaSuperavitCentrus(tipo: Number) {
    this.blockUi.start('Carregando...');
    try {
      const superavitModelRetorno = await this.pbdcService.getPageConsultaSuperavitCentrus(this.cdCentrus, this.cdCentrusTit, tipo, this.nrSuperavit, this.rows, this.page);
      this.totalRecords = superavitModelRetorno['totalElements']
      console.log(superavitModelRetorno)
      this.superavitModel = this._configurarInformacoesLista(superavitModelRetorno['content']);

      if (this.superavitModel.length <= 0) { this.voltarForcada() };
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    } finally {
      this.blockUi.stop();
    }
  }


  voltarForcada(): void {
    this.router.navigate([this.param], { skipLocationChange: true });
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }


  private _configurarInformacoesLista(superavit: Array<SuperavitModel>): Array<SuperavitModel> {
    let descOco;
    let dtReferencia;
    return superavit.map((item, index, lista) => {
      const superavitModel = new SuperavitModel();


      if ((Number(item.tpOcorrencia) === 1001) ||
          (Number(item.tpOcorrencia) === 1012) ||
          (Number(item.tpOcorrencia) === 1014) ||
          (Number(item.tpOcorrencia) === 1216) ||
          (Number(item.tpOcorrencia) === 1217)
      ) {

        if (index === 0) {

            if ((Number(item.tpOcorrencia) === 1001) ||
              (Number(item.tpOcorrencia) === 1012) ||
              (Number(item.tpOcorrencia) === 1014)) {
            descOco = `PARCELAS CREDITADAS NO MÊS Nº 1 A 24`
          }

          if ((Number(item.tpOcorrencia) === 1216) ||
              (Number(item.tpOcorrencia) === 1217)) {
            descOco = `${item.dsOcorrencia}  Nº ${item.nrParcela}`
          }

          dtReferencia = '';
        } else if ((item.dtReferencia === '05/2018') && (this.nrSuperavit === 3) && (Number(item.tpOcorrencia) === 1014)) {
          descOco = `CRÉDITO DE  5 PARCELAS DEST. 2014`
        } else {
          descOco = `${item.dsOcorrencia}  Nº ${item.nrParcela}`
          dtReferencia = '';
        }
      } else if ((index === 0) && (this.nrSuperavit === 3) && (Number(item.tpOcorrencia) === 1000)) {
        descOco = 'CRÉDITO DE 17 PARCELAS DEST. 2012';
        dtReferencia = item.dtReferencia;
      } else if (Number(item.tpOcorrencia) === 1218) {
        descOco = `${item.dsOcorrencia}  Nº ${item.nrParcela}`;
        if (index === 0)
        {
          dtReferencia = item.dtReferencia;
        }
      } else {
        descOco = item.dsOcorrencia;
        dtReferencia = '';
      }
      if (descOco === 'ATUALIZACAO') {
        dtReferencia = item.dtReferencia;
      }

      superavitModel.dsOcorrencia = descOco;
      superavitModel.dtReferencia = dtReferencia;
      superavitModel.cdCentrus = item.cdCentrus;
      superavitModel.cdCentrusTit = item.cdCentrusTit;
      superavitModel.tpOcorrencia = item.tpOcorrencia;
      superavitModel.nrParcela = item.nrParcela;
      superavitModel.cdGrupo = item.cdGrupo;
      superavitModel.vlOcor = item.vlOcor;
      superavitModel.vlSaldo = item.vlSaldo;
      superavitModel.noPessoa = item.noPessoa;

      return superavitModel
    });

  }

  pesquisar(){
    this.tipo = 1;
    this.page = 0;
    this.paginator.changePage(0);
    this.getPageConsultaSuperavitCentrus(this.tipo);
    this.changeDetector.markForCheck();
  }

  pesquisarAssistidos(){
    this.page = 0;
    this.paginator.changePage(0);
    this._gerenciarCodigoIndentificao();
    this.changeDetector.markForCheck();
  }

  pesquisarReversao(){
    this.tipo = 6;
    this.page = 0;
    this.paginator.changePage(0);
    this.getPageConsultaSuperavitCentrus(this.tipo)
    this.changeDetector.markForCheck();
  }

  carregamentoFooter(cdGrupo) {

    if (this.tipo === 1) {
      if (Number(cdGrupo) === 1) {
        this.mensagem = '(*) Participante aposentado - liberação do benefício com base no art. 65 do Regulamento do PBDC.';
      } else {
        this.mensagem = '(*) Resgatável quando em gozo de benefício de prestação continuada ou na hipótese de desligamento do PBDC - art. 53 do Regulamento.';
      }
    } else {
      this.mensagem = '(*) Movimentação permitida apenas na ocorróncia dos eventos previstos no art. 67, parágrafo 8º, do Regulamento do PBDC.';
    }

    if (this.linkPatronal && this.nrSuperavit === 3) {
      this.mensagemFooter = 'Fundo Previdencial de Utilização Patronal'
      this.tipo = 2;
    }


    if (this.linkAssistido && this.tipo !== 4) {
      this.mensagemFooter = 'Extrato da parcela pessoal Assistido.'
      this.tipo = 4;
    }

    if (this.linkPatronalAssistido) {
      this.mensagemFooter = 'Extrato da parcela patronal Assistido.'
      this.tipo = 5;
    }

  }

  async imprimirPagina() {
    try {
      const superavitModelRetorno = await this.pbdcService.getConsultaSuperavitCentrus(this.cdCentrus, this.cdCentrusTit, this.tipo, this.nrSuperavit);
      const listaRetorno = this._configurarInformacoesLista(superavitModelRetorno);
      this.pBDCSuperavitPdf.funcionarios(
        this.titulo,
        this.pessoaDadosSimplicadosModel,
        listaRetorno,
        this.mensagem,
        this.mensagemFooter);
    } catch (error) {
      console.error(error);
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/plano/pbdc-superavit/pbdc-superavit.component.ts